// Baseline Slick carousel settings
const baseSlickSettings = {
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: false,
    swipe: true,
    touchMove: true,
    draggable: true
};

// Utility function to merge settings
function mergeSettings(customSettings) {
    return jQuery.extend(true, {}, baseSlickSettings, customSettings);
}

function initCarousels() {
    jQuery(document).ready(function($) {
        if ($('.features-carousel').length) {
            // Wait for images to load before calculating height
            const $featureImages = $('.feature-card img');
            let imagesLoaded = 0;
            const totalImages = $featureImages.length;
            
            function initializeCarousel() {
                // Calculate height after images are loaded
                let maxHeight = 0;
                $('.feature-card').each(function() {
                    const cardHeight = $(this).outerHeight();
                    if (cardHeight > maxHeight) {
                        maxHeight = cardHeight;
                    }
                });
                
                $('.features-carousel').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 8000,
                    pauseOnHover: true,
                    fade: true,
                    cssEase: 'linear'
                });
                
                // Set height on slick-track after Slick creates it
                $('.features-carousel .slick-track').height(maxHeight);
            }
            
            if (totalImages === 0) {
                // No images, initialize immediately
                initializeCarousel();
            } else {
                // Wait for all images to load
                $featureImages.each(function() {
                    const img = new Image();
                    img.onload = img.onerror = function() {
                        imagesLoaded++;
                        if (imagesLoaded === totalImages) {
                            initializeCarousel();
                        }
                    };
                    img.src = this.src;
                });
            }
            
            // Custom nav icon functionality
            $('.nav-icon-circle').on('click', function(e) {
                e.preventDefault();
                const slideIndex = parseInt($(this).data('slide'));
                $('.features-carousel').slick('slickGoTo', slideIndex);
            });
            
            // Update nav icons when slide changes
            $('.features-carousel').on('afterChange', function(event, slick, currentSlide) {
                $('.nav-icon-circle').removeClass('active');
                $('.nav-icon-circle').eq(currentSlide).addClass('active');
            });
        }
        
        if ($('.leadership-carousel').length) {
            const leadershipSettings = mergeSettings({
                slidesToShow: 5.25,
                responsive: [
                    {
                        breakpoint: 1350,
                        settings: {
                            slidesToShow: 4.5
                        }
                    },
                    {
                        breakpoint: 1150,
                        settings: {
                            slidesToShow: 3.5
                        }
                    },
                    {
                        breakpoint: 930,
                        settings: {
                            slidesToShow: 2.5
                        }
                    },
                    {
                        breakpoint: 660,
                        settings: {
                            slidesToShow: 1.5
                        }
                    },
                    {
                        breakpoint: 420,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
            
            $('.leadership-carousel').slick(leadershipSettings);
        }
        
        if ($('.news-carousel').length) {
            const newsSettings = mergeSettings({
                slidesToShow: 3.25,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.5
                        }
                    }
                ]
            });
            
            $('.news-carousel').slick(newsSettings);
        }
        
        if ($('.offices-carousel').length) {
            const officesSettings = mergeSettings({
                slidesToShow: 4.5,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3.5
                        }
                    },
                    {
                        breakpoint: 920,
                        settings: {
                            slidesToShow: 2.5
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.5
                        }
                    },
                    {
                        breakpoint: 420,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
            
            $('.offices-carousel').slick(officesSettings);
        }
    });
}

initCarousels();